/*@ngInject*/
const OrganizationRepository = function ($q, baseRepository) {

    angular.extend(this, baseRepository);

    this.loadOrganizationById = function (organizationId) {
        const url = `/rest/Organization/${organizationId}`;
        return this.get(url);
    };
};

angular.module('umCore')
    .service('organizationRepository', OrganizationRepository);
